import React from "react";
import { Avatar, Button, Tooltip } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";
import { Localize } from "components/service";
import { timeFormat } from "utils/helper-functions";
import { formatWorkedSeconds, getInitials, getScanPoints, PlaceholderTableLink } from "./event-attendance-helper";

const getDailyScanDetails = (summary) => {
    const scanLogs = summary.scan_logs || [];
    const points = getScanPoints(scanLogs);
    const firstPoint = points[ 0 ];

    return {
        worker: summary.worker,
        subcontractor: summary.subcontractor,
        work_date: summary.work_date,
        worked_seconds: summary.worked_seconds,
        scan_logs: scanLogs,
        points,
        lat: firstPoint?.latitude,
        lng: firstPoint?.longitude,
        isDailySummary: true,
    };
};

const EventAttendanceDailySummaryTableHelper = (openLocation) => {
    const columns = [
        {
            title: <Localize>TABLES.Column_Title_Worker</Localize>,
            dataIndex: "worker",
            width: "18%",
        },
        {
            title: <Localize>TABLES.Column_Title_Subcontractor</Localize>,
            dataIndex: "subcontractor",
            width: "17%",
        },
        {
            title: <Localize>TABLES.Column_Title_Date</Localize>,
            dataIndex: "date",
            width: "11%",
        },
        {
            title: <Localize>TABLES.Column_Title_FirstCheckIn</Localize>,
            dataIndex: "checkInTime",
            width: "16%",
        },
        {
            title: <Localize>TABLES.Column_Title_LastCheckOut</Localize>,
            dataIndex: "checkOutTime",
            width: "16%",
        },
        {
            title: (
                <Tooltip title={ <Localize>TABLES.Tooltip_WorkedHours</Localize> }>
                    <span><Localize>TABLES.Column_Title_WorkedHours</Localize></span>
                </Tooltip>
            ),
            dataIndex: "workedHours",
            width: "11%",
        },
        {
            title: (
                <Tooltip title={ <Localize>TABLES.Tooltip_AttendanceScanLogs</Localize> }>
                    <span><Localize>TABLES.Column_Title_AttendanceScanLogs</Localize></span>
                </Tooltip>
            ),
            dataIndex: "scanLogs",
            align: "center",
            width: "11%",
        },
    ];

    const data = (summaries) => {
        if (!summaries)
        {
            return [];
        }

        return summaries.map((summary) => {
            const workerName = `${ summary.worker.name } ${ summary.worker.surname }`;
            const isCompleted = !!summary.check_out_at;
            const hasLogs = (summary.scan_logs || []).length > 0;

            return {
                key: summary.id,
                worker: (
                    <span className="event-check-logs-worker">
                        <Avatar size={ 32 }>{ getInitials(summary.worker) }</Avatar>
                        <PlaceholderTableLink>{ workerName }</PlaceholderTableLink>
                    </span>
                ),
                subcontractor: <PlaceholderTableLink>{ summary.subcontractor.title }</PlaceholderTableLink>,
                date: timeFormat(summary.work_date || summary.check_in_at, "DD.MM.YYYY"),
                checkInTime: timeFormat(summary.check_in_at, "DD.MM.YYYY HH:mm:ss"),
                checkOutTime: isCompleted ? timeFormat(summary.check_out_at, "DD.MM.YYYY HH:mm:ss") : "-",
                workedHours: formatWorkedSeconds(summary.worked_seconds),
                scanLogs: (
                    <Tooltip title={
                        hasLogs ?
                            <Localize>TABLES.Tooltip_AttendanceScanLogs</Localize> :
                            <Localize>CHECK_LOGS.Tooltip_NoScanLogs</Localize>
                    }>
                        <span>
                            <Button
                                type="text"
                                className="event-attendance-location-button event-attendance-location-button--logs"
                                disabled={ !hasLogs }
                                icon={ <EnvironmentOutlined /> }
                                onClick={ () => openLocation(getDailyScanDetails(summary)) }>
                                <Localize>CHECK_LOGS.Button_ScanLogs</Localize>
                            </Button>
                        </span>
                    </Tooltip>
                ),
            };
        });
    };

    return {
        columns,
        data,
    };
};

export default EventAttendanceDailySummaryTableHelper;
